import React from 'react';
import styled from 'styled-components';
import Scrollspy from 'react-scrollspy'

const NavWrapper = styled.div`
	background-color: #f3f2ec;
	padding: 20px 0;
	border-bottom: 1px solid #d8d8cf;
	top: 0;
	position: sticky;
	z-index: 90000;

    @media screen and (max-width: 650px) { 
        display: none;
    }

	ul {
		text-align: center;
		padding-left: 20px;
		padding-right: 20px;
		li {
            color: #989479;
			text-align: center;
			font-size: 14px;
			text-transform: uppercase;
			position: relative;
            transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

            &.is-current {
                color: #403d3d;
                :after {
                    content: '';
                    position: absolute;
                    bottom: -21px;
                    left: 0;
                    right: 0;
                    height: 2px;
                    background-color: #403d3d;
                    transform-origin: right center;
                }
            }
		}
	}

	@media screen and (max-width: 640px) {
		ul {
			li::marker {
				content: '';
			}
		}
	}

	@media screen and (min-width: 650px) {
		ul {
			display: flex;
			justify-content: space-between;
		}
	}
`;

const SectorsNavBar = () => {
	return (
		<NavWrapper>
			<div className="container">
                <Scrollspy items={ ['access-to-ppe', 'economic-empowerment', 'job-creation', 'section-4', 'upskilling'] } offset={-200} currentClassName="is-current">
                    <li><a href="#access-to-ppe">Access to PPE</a></li>
                    <li><a href="#economic-empowerment">Economic Empowerment</a></li>
                    <li><a href="#job-creation">Job Creation</a></li>
                    <li><a href="#section-4">Financial Inclusion</a></li>
                    <li><a href="#upskilling">Upskilling</a></li>
                </Scrollspy>
			</div>
		</NavWrapper>
	);
};

export default SectorsNavBar;
